import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {faStar} from '@fortawesome/free-solid-svg-icons';
import {MetricService} from 'app/blocks/service/api/metric.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IMetric, Metric} from 'app/blocks/model/metric.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class MetricResource extends AbstractEntityResource<IMetric> {
    constructor(metricService: MetricService, router: Router) {
        super(
            Resource.METRICS,
            metricService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.METRICS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.METRICS),
            (entity?) => new Metric(entity),
            (entity) => entity.id,
            faStar
        );
    }
}
